var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityRampedSlopedAccessThatIsLongSteepMayHaveManualDoors = function SvgAccessibilityRampedSlopedAccessThatIsLongSteepMayHaveManualDoors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m16.177 21.241 8.313 1.788a.894.894 0 0 0 1.118-.894V2.201a.965.965 0 0 0-1.118-.939L16.177 3.05a.95.95 0 0 0-.76.894v16.358a.965.965 0 0 0 .76.94zM4.199 26.694l11.486-5.721M4.199 26.694l9.296 2.056m0 0 12.158-.85m.148 0v-5.452M13.495 28.75l11.532-5.676"
  })));
};
export default SvgAccessibilityRampedSlopedAccessThatIsLongSteepMayHaveManualDoors;